module.exports = new Promise((resolve, reject) => {
      const url = window.__REMOTES__?.["fusion"] || "http://localhost:8520/remoteEntry.js";
      const script = document.createElement("script");
      script.src = url;
      script.onload = () => resolve(window["fusion"]);
      script.onerror = (e) => reject(new Error("Failed to load remote: fusion from " + url));
      document.head.appendChild(script);
    });